module.exports = __webpack_public_path__ + "static/media/SWSCRC6-35.3dd87c24.mp3";